import OnBoarding from './OnBoardingBase';

export * from './+store';
export default OnBoarding;
